module.exports = __webpack_public_path__ + "static/media/alarm.7e70c5e8.mp3";